'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = InputDescription;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = require('jss-theme-reactor');

var _Text = require('../Text');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('InputDescription', function (theme) {
  var mixins = theme.mixins,
      typography = theme.typography,
      variables = theme.variables;

  return {
    root: Object.assign({
      width: '100%',
      maxWidth: '100%',
      textAlign: 'left',
      margin: variables.formControlMarginTop + 'px 0 ' + typography.rhythmByUnit(-2)
    }, typography.description),
    ellipsize: mixins.truncate()
  };
});

function InputDescription(props, context) {
  var children = props.children,
      classNameProp = props.className,
      floatingLabelFixed = props.floatingLabelFixed,
      label = props.label,
      other = _objectWithoutProperties(props, ['children', 'className', 'floatingLabelFixed', 'label']);

  var classes = context.styleManager.render(styleSheet);
  var className = (0, _classnames2['default'])(classes.root, _defineProperty({}, classes.ellipsize, !floatingLabelFixed && label), classNameProp);

  return _react2['default'].createElement(
    _Text.Body1,
    _extends({ className: className }, other),
    children
  );
}

InputDescription.displayName = 'InputDescription';

InputDescription.propTypes = {
  /**
   * The contents of the InputDescription.
   */
  children: _PropTypes2['default'].node,
  /**
   * The css class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * If 'true', floating label will float even when there is no value
   */
  floatingLabelFixed: _PropTypes2['default'].bool,
  /**
   * If true, the input of this description has a label.
   */
  label: _PropTypes2['default'].bool
};

InputDescription.defaultProps = {
  floatingLabelFixed: true,
  label: false
};

InputDescription.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/Input/InputDescription.js
// module id = 1855
// module chunks = 32